import React, { Component } from 'react';
import { Row } from 'antd';
import BookingTimeColumn from './BookingTimeColumn';
import StatusMessage from '../StatusMessage';
import LoadingSpinner from '../LoadingSpinner';
import { validateHasTimesAvailable } from '../../constants/formValidation';


const INITIAL_STATE = {
    availableMorningTimes: [
        '9:00 am',
        '9:30 am',
        '10:00 am',
        '10:30 am',
        '11:00 am',
    ],
    availableLunchTimes: [
        '11:30 am',
        '12:00 pm',
        '12:30 pm',
        '1:00 pm',
        '1:30 pm',
    ],
    availableNoonTimes: [
        '2:00 pm',
        '2:30 pm',
        '3:00 pm',
        '3:30 pm',
        '4:00 pm',
    ],
};

class BookingTime extends Component {
    state = {
        hasTimesAvailable: false,
        ...INITIAL_STATE
    };

    componentDidMount() {
        this.updateAvailableTimes();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectedDate !== this.props.selectedDate) {
            this.updateAvailableTimes();
        }
    }

    updateAvailableTimes = () => {
        this.setState({
            availableMorningTimes: this.filterAvailableTimes('availableMorningTimes'),
            availableLunchTimes: this.filterAvailableTimes('availableLunchTimes'),
            availableNoonTimes: this.filterAvailableTimes('availableNoonTimes'),
        }, this.calculateHasTimesAvailable);
    }

    filterAvailableTimes = key => {
        const allTimes = INITIAL_STATE[key];
        const { unavailableTimeSlots } = this.props;

        return allTimes.filter(time => !unavailableTimeSlots.includes(time));
    }

    calculateHasTimesAvailable = () => {
        const { selectedDate, unavailableDays } = this.props;
        const {
            availableMorningTimes,
            availableLunchTimes,
            availableNoonTimes,
        } = this.state;

        const bookingTimes = [
            ...availableMorningTimes,
            ...availableLunchTimes,
            ...availableNoonTimes,
        ];

        this.setState({
            hasTimesAvailable: validateHasTimesAvailable(selectedDate, unavailableDays, bookingTimes),
        });
    }

    handleButtonClick = time => e => {
        e.preventDefault();

        this.props.handleSubmit(time);
    }

    render() {
        const {
            hasTimesAvailable,
            availableMorningTimes,
            availableLunchTimes,
            availableNoonTimes,
        } = this.state;
        const { loading } = this.props;

        if (loading) {
            return <LoadingSpinner/>;
        }

        if (!hasTimesAvailable) {
            return (
                <StatusMessage
                    message="Sorry, no times are available on this day."
                    variant="error"
                />
            );
        }

        return (
            <>
                <Row>
                    <BookingTimeColumn
                        label="Morning"
                        times={availableMorningTimes}
                        onClick={this.handleButtonClick}
                    />
                    <BookingTimeColumn
                        label="Lunchtime"
                        times={availableLunchTimes}
                        onClick={this.handleButtonClick}
                    />
                    <BookingTimeColumn
                        label="Noon"
                        times={availableNoonTimes}
                        onClick={this.handleButtonClick}
                    />
                </Row>
            </>
        );
    }
}

export default BookingTime;
